<div class="dialog-container">
    <div class="closewrapper">
        <div class="closealert d-flex">
            <div class="text-heading-4">Delete Product Category from Master</div>
            <div class="flex-container gap-2">
                <div class="dialog-btn " (click)="onClose()">
                    <img class="dialog-colse-btn closedialog" src="../../../assets/images/close.png" alt="close">
                </div> 
            </div>
        </div>

        <div class="closealertcontent">
            Are you sure you want to delete the product category? If you delete, the data mapped under this category still remains but you can’t add anymore under this category.
        </div>
        <div class="updatealert-section"> 
          <button class="primary-btn updateno-content" (click)="cancel()">No</button>
          <button class="primary-btn close-content" (click)="confirmClose()">Yes, Close</button>
        </div>
      </div>
  </div>

 